/**
 * BrandMark — the official Fieldlink NZ logo.
 * Variant:
 *   "mark"     — square FL bolt icon for tight slots (sidebar, top bar)
 *   "full"     — square logo with bolt + word-mark + tagline
 *   "wordmark" — bolt icon + "FIELDLINK NZ" text inline lockup
 */
const LOGO_SRC = "/brand/fieldlink-logo.jpg";

function Mark({ size, className }) {
  return (
    <div
      className={`relative shrink-0 overflow-hidden rounded ${className || ""}`}
      style={{ width: size, height: size, background: "#000" }}
      aria-label="Fieldlink NZ"
    >
      <img
        src={LOGO_SRC}
        alt="Fieldlink NZ"
        className="absolute inset-0 w-full pointer-events-none select-none"
        style={{
          height: size * 1.6,
          objectFit: "cover",
          objectPosition: "center 25%",
          top: "-18%",
        }}
        draggable={false}
      />
    </div>
  );
}

export function BrandMark({ variant = "mark", size = 32, className = "" }) {
  if (variant === "full") {
    return (
      <img
        src={LOGO_SRC}
        alt="Fieldlink NZ — Connected on site"
        className={`block ${className}`}
        style={{ width: size, height: size }}
        draggable={false}
      />
    );
  }
  if (variant === "wordmark") {
    return (
      <div className={`inline-flex items-center gap-2 ${className}`}>
        <Mark size={size} />
        <div className="font-display font-black tracking-tight leading-none text-base">
          FIELDLINK<span className="text-[#FF5F15]">NZ</span>
        </div>
      </div>
    );
  }
  return <Mark size={size} className={className} />;
}
